module.exports = __webpack_public_path__ + "media/images/metronic/portlet-remove-icon-white-94cf6cf60dc8f08fd3dc610564510104.png";